export default "__VITE_ASSET__45cdf9f7__"